/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
akhila 11/11/2022 3075234474 added new UI Fields for Reports
akhila 11/11/2022 3075234474 Integrated save and get api
Saikrishna 11/28/2022 3075234474 Fixed report master and fixed length conditions.
Saikrishna 12/07/2022 3075234474 Added notify email fields according to required changes.
Saikrishna 12/07/2022 3075234474 Added work queue fields to additional info step .
kavya9reddy 12/08/2022 3075234474 Added save button
Sai maheshwar 12/08/2022 3031450488 fixed unsaved changes alert bug
Sohel 12/13/2022 3031450488 conditionally hide Save Button
Raghuarun 12/21/2022 3031450488 button spacing alignments
sai Krishna 12/23/2022 3031450488 add Work Queue code, Reportcode  and Work Queue description,Report description
lalitha 12/26/2022 3031450488 fixed prepopulating issue of report code and report description when clicked on edit.
Ashraf 12/27/2022 3031450488 renamed field show dashboard to show work queue list
lalitha 1/19/2022 3031450488 fixed Popup toast Messege issue .
dilip 01/31/2023 3031450488 Show WOrk Queue List option changes
Akhila 02/08/2023 3031450488 bug Fixed invalid email validation on notify email
Prakash 02/13/2023 3031450488 Added New UI Style-classes for fields and buttons.
Sohel 02/13/2022 3031450488 roles dropdown issue
Akhila 02/10/2023 3031450488 implemented autoComplete field for existing show work queue list and filter select field
Prakash 02/14/2023 3031450488 Implemented New UI Changes for Autocomplete Component.
Prakash 02/16/2023 2698964415 Fixed UI-Bug.
Raghu 02/27/2023 2698964415 alignment fixes
 Rohini 03/01/2023 2698964415 removed the class
 Ravi 04/20/2023 2698964415 implement dynamic field name
 Prakash 24/04/2023 2698964415 Fixed dynamic field input field
Ravi 04/24/2023 2698964415 Added popup in dynamic field name
Akhila 05/16/2023 2698964415 modfied in condtion for field seprator and report output format
Sohel 22/05/2023 3031450488 Fixed Created For Issue
Akhila 06/15/2023 3031450488 added report path field
Ravi 06/15/2023 3031450488 Added value code in dropdown in seperator
Akhila 06/16/2023 3075154998 modified report folder path field
Ravi 06/27/2023 3031450488 fixed prepopulate issue in Work Queue users and Roles
Ravi 06/15/2023 3075154998 removed by default initial value folder path and output file name
Ravi 07/18/2023 3075154998 show work Queue Filter field Conditionally
*/
import {
  Button,
  FormHelperText,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import {Formik} from 'formik';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {getOptions} from './../../../../../util/GetDropDownOptions';
import {getDropDownData} from './../../../../../redux/reducers/BRE/AddRecordFormat';
import {FILE_TYPE, FIELD_SEPERATOR} from './../../../../../constants/Lookup';
import {
  fetchAdditionalInfo,
  fetchBasicInfo,
  postAdditionalInfo,
  resetAdditionalInfo,
  getAllWorkqueueNameData,
} from '../../../../../redux/reducers/ReportMaster';
import {SuccessSnackbar, ErrorSnackbar} from './../../../../../components/CustomSnackBar/index';
import PageLoader from './../../../../../components/PageLoader/index';
import {
  reportMasterRoleName,
  reportMasterUserName,
} from './../../../../../redux/reducers/BRE/AddReportMaster';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {REPORTING_EXPORT} from '../../../../../constants/ReusableRoleAccess';
import BreadCrums from '../../../../../util/BreadCrum';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import AddFileName from './AddFileName';
import DialogBox from '../../../../../components/DialogBox';
import ReportFolderPath from './ReportFolderPath';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
const AdditionalInfo = ({
  handleBack,
  handleNext,
  workQueue,
  handleDirty,
  editExisting,
}) => {
  const dispatch = useDispatch();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {dropDownData} = useSelector(({addRecordFormat}) => addRecordFormat);
  const {roleData} = useSelector(({role}) => role);
  const [open, setOpen] = useState(false);
  const [folderPath, setFolderPath] = useState(false);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const {
    isLoading,
    successMsg,
    errorMsg,
    reportCode,
    additionalInfoData,
    addAdditionalInfoStatus,
    fixedlength,
    basicInfoData,
  } = useSelector(({reportMaster}) => reportMaster);
  const roleAccess = additionalInfoData?.displayHeader && !reportRoleAccess?.edit && editExisting;
  const saveRef = useRef();
  const getObjects = (option, typeCode) => {
    const options = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option.toString() || item.value === option) {
          label = item;
        }
      });
    return label;
  };

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option || item.key === option || item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const displayHeaderData = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  const handleClose = () => {
    setOpen(false);
    setFolderPath(false);
  };

  useEffect(() => {
    if (reportCode) {
      dispatch(fetchAdditionalInfo(reportCode));
    }
    dispatch(getDropDownData());
    dispatch(reportMasterUserName());
    dispatch(reportMasterRoleName());
    dispatch(getAllWorkqueueNameData());
  }, []);

  const initialValues = {
    displayHeader: additionalInfoData?.displayHeader ?
      getObject(additionalInfoData?.displayHeader, displayHeaderData) :
      getObject('N', displayHeaderData),
    reportFormat:
      // fixedlength === "Y"
      //   ? getObjects("Text", FILE_TYPE, dropDownData)
      additionalInfoData?.reportFormat ?
        getObjects(additionalInfoData?.reportFormat, FILE_TYPE, dropDownData) :
        getObjects('CSV', FILE_TYPE, dropDownData),
    fieldSeparator: additionalInfoData?.fieldSeparator ?
      getObjects(additionalInfoData?.fieldSeparator, FIELD_SEPERATOR, dropDownData) :
      {valueCode: 'comma', value: ','},
    notifyCompletion:
      additionalInfoData?.notifyCompletionEmails?.length > 0 &&
      typeof additionalInfoData?.notifyCompletionEmails === 'object' ?
        additionalInfoData?.notifyCompletionEmails?.join(',') :
        '',
    notifyError:
      additionalInfoData?.notifyErrorEmails?.length > 0 &&
      typeof additionalInfoData?.notifyErrorEmails === 'object' ?
        additionalInfoData?.notifyErrorEmails?.join(',') :
        '',
    outputFileName: additionalInfoData?.reportOutputFileName ?
      additionalInfoData?.reportOutputFileName :
      '',
    reportpath: additionalInfoData?.reportfolderPath ? additionalInfoData?.reportfolderPath : '',
  };

  const schema = Yup.object().shape({
    displayHeader: Yup.mixed().test('displayHeader', 'Display Header is required', (value) => {
      if (!value) {
        return false;
      } else {
        return true;
      }
    }),
    reportFormat: Yup.mixed().test('workQueue', 'Report Format Type is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    fieldSeparator: Yup.mixed().test(
      'fieldSeparator',
      'Field Separator is required',
      (value, ctx) => {
        if (!value?.value && fixedlength === 'N') {
          return false;
        } else {
          return true;
        }
      },
    ),
    notifyCompletion: Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    notifyError: Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
      if (value?.length) {
        const modifiedValue = value?.split(',');
        const reqArr =
          modifiedValue && modifiedValue?.length > 0 ?
            modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
            [];
        if (reqArr?.length === modifiedValue?.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    }),
    reportpath: Yup.mixed().test(
      'reportpath',
        `Invalid Folder path, Can't contain // and \\`,
        function(value, context) {
          const regex = /^(?!.*\\|.*\/\/).*$/;
          const {parent} = context;
          if (regex.test(parent?.reportpath)) {
            return true;
          } else {
            return false;
          }
        },
    ),
  });

  useEffect(() => {
    if (addAdditionalInfoStatus === 200) {
      setTimeout(() => {
        dispatch(resetAdditionalInfo());
        !saveRef.current && handleNext();
      }, 2000);
    }
  }, [addAdditionalInfoStatus]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetAdditionalInfo());
      }, 2000);
    }
  }, [errorMsg, successMsg]);
  useEffect(() => {
    if (reportCode) {
      dispatch(fetchBasicInfo(reportCode));
    }
  }, [reportCode]);

  const onSubmit = (data) => {
    dispatch(submissionStart());
    const payload = {
      displayHeader: data?.displayHeader?.value ?
        data?.displayHeader?.value === 'Yes' ?
          'Y' :
          'N' :
        '',
      fieldSeparator: data?.fieldSeparator?.value ? data?.fieldSeparator?.value : '',
      notifyCompletionEmails: data?.notifyCompletion.length ?
        data?.notifyCompletion?.split(',') :
        [],
      notifyErrorEmails: data?.notifyError.length ? data?.notifyError?.split(',') : [],
      reportCode: basicInfoData?.reportCode ? basicInfoData?.reportCode : '',
      reportId: reportCode ? reportCode : 0,
      reportFormat: data?.reportFormat?.value ? data?.reportFormat?.value : '',
      lastStep: saveRef.current ? 3 : 4,
      reportOutputFileName: data?.outputFileName ? data?.outputFileName : '',
      reportfolderPath: data?.reportpath ? data?.reportpath : '',
    };
    dispatch(postAdditionalInfo(payload));
  };

  return (
    <>
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            handleBlur,
            handleChange,
            errors,
            touched,
            handleSubmit,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              {workQueue ? (
                <BreadCrums
                  name={'Work Queue Code'}
                  code={basicInfoData?.reportCode}
                  description={'Work Queue Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              ) : (
                <BreadCrums
                  name={'Report Name'}
                  code={basicInfoData?.reportCode}
                  description={'Report Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              )}
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div className="new-standard-textfields form-row global-field-textfields">
                  {/* {values?.reportFormat?.value !== "Excel" && fixedlength === "N" && ( */}
                  <div className="col-sm-6 col-md-4 col-lg-4 form-group py-1">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="fieldSeparator"
                      size="small"
                      value={values?.fieldSeparator}
                      autoHighlight
                      options={getOptions(FIELD_SEPERATOR, dropDownData)}
                      getOptionLabel={(option) => {
                        return option && option?.value ? option?.value : '';
                      }}
                      renderOption={(option) => {
                        return option?.value ? option?.value + '  ' + `(${option?.valueCode})` : '';
                      }}
                      onChange={(_, data) => {
                        setFieldValue('fieldSeparator', data);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Field Separator"
                            name="fieldSeparator"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            required={fixedlength === 'N'}
                            error={Boolean(touched.fieldSeparator && errors.fieldSeparator)}
                            placeholder="Select Field Separator"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{color: 'red', paddingTop: '5px'}} variant="outlined">
                      {touched.fieldSeparator && errors.fieldSeparator && errors.fieldSeparator}
                    </FormHelperText>
                  </div>
                  {/* )} */}
                  <div className="col-sm-6 col-md-4 col-lg-4 form-group py-1">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="displayHeader"
                      size="small"
                      value={values?.displayHeader}
                      autoHighlight
                      options={displayHeaderData}
                      getOptionLabel={(option) => {
                        return option && option?.value ? option?.value : '';
                      }}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      onChange={(_, data) => {
                        setFieldValue('displayHeader', data);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Display Header"
                            name="displayHeader"
                            required
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            error={Boolean(touched.displayHeader && errors.displayHeader)}
                            placeholder="Select Display Header"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{color: 'red', paddingTop: '5px'}} variant="outlined">
                      {touched.displayHeader && errors.displayHeader && errors.displayHeader}
                    </FormHelperText>
                  </div>
                  <div className="col-sm-6 col-md-4 col-lg-4 form-group py-1">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="reportFormat"
                      size="small"
                      autoHighlight
                      value={values?.reportFormat}
                      options={
                        getOptions(FILE_TYPE, dropDownData)
                      }
                      getOptionDisabled={(option) => option?.valueCode === 'none'}
                      getOptionLabel={(option) => {
                        return option && option?.value ?
                          option?.valueCode === null ?
                            option?.value :
                            option?.valueCode + ' - ' + option?.value :
                          '';
                      }}
                      onChange={(_, data) => {
                        setFieldValue('reportFormat', data);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Report Format Type"
                            error={Boolean(touched.reportFormat && errors.reportFormat)}
                            name="reportFormat"
                            required
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            placeholder="Select Report Format Type"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{color: 'red', paddingTop: '5px'}} variant="outlined">
                      {touched.reportFormat && errors.reportFormat && errors.reportFormat}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-6 col-md-4 col-lg-4 form-group py-1`}>
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Enter Notify Completion Email"
                      margin="dense"
                      name="notifyCompletion"
                      variant="outlined"
                      value={values?.notifyCompletion}
                      label="Notify Completion Email"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      // required
                      onBlur={handleBlur}
                      onChange={(e) => {
                        handleChange(e);
                        setFieldValue('notifyCompletion', e.target.value);
                        // if (e.target.value) {
                        //   setCodePopover(true);
                        //   setReportCodesData(e.target.value);
                        // } else if (e.target.value === "") {
                        //   setCodePopover(false);
                        // }
                      }}
                      // touched={touched.notifyCompletion}
                      // error={Boolean(errors.notifyCompletion && touched.notifyCompletion)}
                      fullWidth
                    />
                    <FormHelperText style={{color: 'red', paddingTop: '5px'}} variant="outlined">
                      {touched.notifyCompletion && errors.notifyCompletion}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-6 col-md-4 col-lg-4 form-group py-1`}>
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Enter Notify Error Emails"
                      margin="dense"
                      name="notifyError"
                      variant="outlined"
                      value={values?.notifyError}
                      label="Notify Error Emails"
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      // required
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue('notifyError', e.target.value);
                      }}
                      fullWidth
                    />
                    <FormHelperText style={{color: 'red', paddingTop: '5px'}} variant="outlined">
                      {touched.notifyError && errors.notifyError}
                    </FormHelperText>
                  </div>

                  <div className={`col-sm-6 col-md-4 col-xl-4 form-group py-1 reportout-filed`}>
                    <TextField
                      className={` ${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Report Folder Path`}
                      label={'Report Folder Path'}
                      multiline
                      rows={2}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            style={{cursor: 'pointer'}}
                            onClick={() => setFolderPath(true)}
                            position="start"
                          >
                            <AddBoxOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      name={'reportpath'}
                      value={values?.reportpath}
                      onChange={(e) => {
                        setFieldValue('reportpath', e.target.value);
                      }}
                      fullWidth
                      touched={touched.reportpath}
                      error={touched.reportpath && errors.reportpath}
                    />
                    <FormHelperText style={{color: 'red', paddingTop: '5px'}} variant="outlined">
                      {touched.reportpath && errors.reportpath && errors.reportpath}
                      {''}
                    </FormHelperText>
                  </div>
                  <div className={`col-sm-6 col-md-4 col-xl-4 form-group py-1 reportout-filed`}>
                    <TextField
                      className={` ${classes.labelName}`}
                      margin="dense"
                      variant="outlined"
                      placeholder={`Enter Report Output File Name`}
                      label={'Report Output File Name'}
                      multiline
                      rows={2}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            style={{cursor: 'pointer'}}
                            onClick={() => setOpen(true)}
                            position="start"
                          >
                            <AddBoxOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      name={'outputFileName'}
                      value={values?.outputFileName}
                      onChange={(e) => {
                        setFieldValue('outputFileName', e.target.value);
                      }}
                      fullWidth
                      touched={touched.outputFileName}
                    />
                  </div>
                </div>
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  hideFooter={true}
                  maxWidth={'xl'}
                  title={'Report File Name'}
                >
                  <AddFileName
                    setFieldValues={setFieldValue}
                    setOpen={setOpen}
                    addValues={values}
                    handleClose={handleClose}
                    folderPath={folderPath}
                  />
                </DialogBox>
                <DialogBox
                  open={folderPath}
                  dialogClose={handleClose}
                  hideFooter={true}
                  maxWidth={'xl'}
                  title={'Report Folder Path'}
                >
                  <ReportFolderPath
                    setFieldValues={setFieldValue}
                    setOpen={setOpen}
                    addValues={values}
                    handleClose={handleClose}
                    folderPath={folderPath}
                  />
                </DialogBox>

                <div className="new-standard-textfields d-flex justify-content-center">
                  <Button
                    variant="outlined"
                    onClick={handleBack}
                    className={`reset-btn mr-1 ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {isDraftReport === "N" && ( */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    disabled={roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn ml-1 ${classes.buttonRoot}`}
                    disabled={roleAccess || enabledSubmission}
                    onClick={() => {
                      saveRef.current = false;
                    }}
                  >
                    Save & Next
                  </Button>
                </div>
              </form>
            </>
          );
        }}
      </Formik>
      {isLoading && <PageLoader />}
      {errorMsg && (
        <ErrorSnackbar errorMsg={ errorMsg} />
      )}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default AdditionalInfo;
